
<div class="ws-accent-card" [ngClass]="isFlagged ? 'ws-accent-card--error' : 'ws-accent-card--teal'">
    <div class="ws-accent-card__head">
        <h3 class="ws-accent-card__title">Surveys</h3>
        <span class="ws-accent-card__empty-marker" *ngIf="disabled">&mdash;</span>
    </div>
    <div class="ws-accent-card__body">

        <!-- Patient: solo Wellbeing Quiz -->
        <div class="d-flex gap-3" *ngIf="type=='patient'">
            <div class="text-center">
                <span style="font-weight: 600;">Eating Disorder-15 (ED-15)</span> <br>
                <span class="mt-2 badge fs-6" style="color:#000 !important; border-radius: 20px; padding-left: 40px; padding-right: 40px;"
                      [ngClass]="disabled || ed15 == undefined? 'text-bg-neutral' : 'text-bg-warning'">
                    @if (disabled || ed15 == undefined) {
                        -
                    }
                    @else {
                        {{ ed15.score }}
                    }
                    <cdss-trend-icon [trend]="trendOf(ed15)"></cdss-trend-icon>
                </span>
            </div>
        </div>

        <!-- Carer: PHQ-9 + GAD-7 -->
        <div class="d-flex justify-content-around gap-3" *ngIf="type!='patient'">
            <div class="px-4 text-center">
                PHQ-9 <br>
                <span class="mt-2 badge fs-6" style="color:#000 !important; border-radius: 20px; padding-left: 40px; padding-right: 40px;"
                      [class.text-bg-neutral]="disabled || phq9 == undefined"
                      [style.background]="(!disabled && phq9 != undefined) ? 'var(--surface-warning, rgba(254, 234, 177, 1))' : null">
                    @if (disabled || phq9 == undefined) {
                        -
                    }
                    @else {
                        {{ phq9.score }}
                    }
                    <cdss-trend-icon [trend]="trendOf(phq9)"></cdss-trend-icon>
                </span>
            </div>
            <div class="px-4 text-center">
                GAD-7 <br>
                <span class="mt-2 badge fs-6" style="color:#000 !important; border-radius: 20px; padding-left: 40px; padding-right: 40px;"
                      [class.text-bg-neutral]="disabled || gad == undefined"
                      [style.background]="(!disabled && gad != undefined) ? 'var(--surface-warning, rgba(254, 234, 177, 1))' : null">
                    @if (disabled || gad == undefined) {
                        -
                    }
                    @else {
                        {{ gad.score }}
                    }
                    <cdss-trend-icon [trend]="trendOf(gad)"></cdss-trend-icon>
                </span>
            </div>
        </div>

    </div>
</div>
